import { useTranslate } from '@tolgee/react';
import CreatorCard from '../commonElements/creatorCard';
import CreatorTitle from '../commonElements/creatorTitle';
import { useState } from 'react';
import { CreatorVerticalSeparator } from '../include/VerticalSeperator';
import { TagsInput } from 'react-tag-input-component';
import { useDispatch, useSelector } from '../../../../redux/store';
import { ALL, PLATFORM_LIST_WITH_ALL } from '../../../../config/constants';
import { setPostDataAttribute } from '../../../../redux/slices/lomavisCreator/lomavisCreator';
import toast from 'react-hot-toast';
export const GeneralAdditionalOptions: React.FC<any> = ({ prefix }: any) => {
  const { t } = useTranslate();
  const [showLinks, setShowLinks] = useState(false);
  const {
    postData: {
      [ALL]: {
        [prefix + '_contact_email']: contact,
        [prefix + '_more_information_link']: informationLink,
        [prefix + '_tags']: tags,
        [prefix + '_url_link']: urlLink
      }
    }
  } = useSelector((state: any) => state.lomavisCreator);
  const dispatch = useDispatch();
  return (
    <CreatorCard>
      <CreatorTitle title="AdditionalOptionsButtons" />
      <span className="text-muted">
        {t('lomavisCreator.additionalOptions.generalHelpText')}
      </span>
      {
        // add 3 fields : contact, go to info, more info
      }
      <CreatorVerticalSeparator />
      <label htmlFor="contact">
        {t('lomavisCreator.additionalOptions.contact')}
      </label>
      <input
        id="contact"
        type="text"
        className="form-control form-control-sm"
        maxLength={254}
        value={contact}
        onChange={(e) => {
          PLATFORM_LIST_WITH_ALL.forEach((platform) => {
            dispatch(
              setPostDataAttribute({
                platform: platform,
                attribute: prefix + '_contact_email',
                value: e.target.value
              })
            );
          });
        }}
      />
      <span className="text-muted">
        {t('lomavisCreator.additionalOptions.contactHelpText')}
      </span>
      <CreatorVerticalSeparator />
      <label htmlFor="go-to-info">
        {t('lomavisCreator.additionalOptions.goToInfo')}
      </label>
      <input
        id="go-to-info"
        type="text"
        className="form-control form-control-sm"
        maxLength={2000}
        value={informationLink}
        onChange={(e) => {
          PLATFORM_LIST_WITH_ALL.forEach((platform) => {
            dispatch(
              setPostDataAttribute({
                platform: platform,
                attribute: prefix + '_more_information_link',
                value: e.target.value
              })
            );
          });
        }}
      />
      <span className="text-muted">
        {t('lomavisCreator.additionalOptions.goToInfoHelpText')}
      </span>
      <CreatorVerticalSeparator />
      <label htmlFor="more-info">
        {t('lomavisCreator.additionalOptions.moreInfo')}
      </label>
      <input
        id="more-info"
        type="text"
        className="form-control form-control-sm"
        maxLength={2000}
        value={urlLink}
        onChange={(e) => {
          PLATFORM_LIST_WITH_ALL.forEach((platform) => {
            dispatch(
              setPostDataAttribute({
                platform: platform,
                attribute: prefix + '_url_link',
                value: e.target.value
              })
            );
          });
        }}
      />
      <span className="text-muted">
        {t('lomavisCreator.additionalOptions.moreInfoHelpText')}
      </span>

      <CreatorVerticalSeparator />
      <label htmlFor="tags">{t('lomavisCreator.additionalOptions.tags')}</label>
      <TagsInput
        value={tags || []}
        onExisting={(newTags) =>
          toast.error(t('lomavisCreator.additionalOptions.tagsDuplicateError'))
        }
        onChange={(newTags) => {
          PLATFORM_LIST_WITH_ALL.forEach((platform) => {
            dispatch(
              setPostDataAttribute({
                platform: platform,
                attribute: prefix + '_tags',
                value: newTags
              })
            );
          });
        }}
        name="tags"
        placeHolder={t('lomavisCreator.additionalOptions.tags')}
      />
      <span className="text-muted">
        {t('lomavisCreator.additionalOptions.tagsHelpText')}
      </span>

      <CreatorVerticalSeparator />
      <div>
        <button
          className="btn btn-secondary btn-sm"
          onClick={() => setShowLinks(!showLinks)}
        >
          {t('lomavisCreator.additionalOptions.addLink')}
        </button>
      </div>
      {showLinks && <LinksAdditionalOptions prefix={prefix} />}
    </CreatorCard>
  );
};

const LinksAdditionalOptions: React.FC<any> = ({ prefix }: any) => {
  const { t } = useTranslate();
  const {
    postData: {
      [ALL]: {
        [prefix + '_link1_title']: link1Title,
        [prefix + '_link1']: link1Url,
        [prefix + '_link2_title']: link2Title,
        [prefix + '_link2']: link2Url,
        [prefix + '_link3_title']: link3Title,
        [prefix + '_link3']: link3Url
      }
    }
  } = useSelector((state: any) => state.lomavisCreator);
  const dispatch = useDispatch();
  return (
    <div>
      <div className="mt-3" />
      <div className="text-muted">
        {t('lomavisCreator.additionalOptions.linksHelpText')}
      </div>
      <CreatorVerticalSeparator />
      <label htmlFor="link1-title">
        {t('lomavisCreator.additionalOptions.link1_title')}
      </label>
      <input
        id="link1-title"
        type="text"
        className="form-control form-control-sm"
        maxLength={50}
        value={link1Title}
        onChange={(e) => {
          PLATFORM_LIST_WITH_ALL.forEach((platform) => {
            dispatch(
              setPostDataAttribute({
                platform: platform,
                attribute: prefix + '_link1_title',
                value: e.target.value
              })
            );
          });
        }}
      />
      <label htmlFor="link1-url">
        {t('lomavisCreator.additionalOptions.link1_url')}
      </label>
      <input
        id="link1-url"
        type="text"
        className="form-control form-control-sm"
        maxLength={2000}
        value={link1Url}
        onChange={(e) => {
          PLATFORM_LIST_WITH_ALL.forEach((platform) => {
            dispatch(
              setPostDataAttribute({
                platform: platform,
                attribute: prefix + '_link1',
                value: e.target.value
              })
            );
          });
        }}
      />
      <CreatorVerticalSeparator />
      <label htmlFor="link2-title">
        {t('lomavisCreator.additionalOptions.link2_title')}
      </label>
      <input
        id="link2-title"
        type="text"
        className="form-control form-control-sm"
        maxLength={50}
        value={link2Title}
        onChange={(e) => {
          PLATFORM_LIST_WITH_ALL.forEach((platform) => {
            dispatch(
              setPostDataAttribute({
                platform: platform,
                attribute: prefix + '_link2_title',
                value: e.target.value
              })
            );
          });
        }}
      />
      <label htmlFor="link2-url">
        {t('lomavisCreator.additionalOptions.link2_url')}
      </label>
      <input
        id="link2-url"
        type="text"
        className="form-control form-control-sm"
        maxLength={2000}
        value={link2Url}
        onChange={(e) => {
          PLATFORM_LIST_WITH_ALL.forEach((platform) => {
            dispatch(
              setPostDataAttribute({
                platform: platform,
                attribute: prefix + '_link2',
                value: e.target.value
              })
            );
          });
        }}
      />
      <CreatorVerticalSeparator />
      <label htmlFor="link3-title">
        {t('lomavisCreator.additionalOptions.link3_title')}
      </label>
      <input
        id="link3-title"
        type="text"
        className="form-control form-control-sm"
        maxLength={50}
        value={link3Title}
        onChange={(e) => {
          PLATFORM_LIST_WITH_ALL.forEach((platform) => {
            dispatch(
              setPostDataAttribute({
                platform: platform,
                attribute: prefix + '_link3_title',
                value: e.target.value
              })
            );
          });
        }}
      />
      <label htmlFor="link3-url">
        {t('lomavisCreator.additionalOptions.link3_url')}
      </label>
      <input
        id="link3-url"
        type="text"
        className="form-control form-control-sm"
        maxLength={2000}
        value={link3Url}
        onChange={(e) => {
          PLATFORM_LIST_WITH_ALL.forEach((platform) => {
            dispatch(
              setPostDataAttribute({
                platform: platform,
                attribute: prefix + '_link3',
                value: e.target.value
              })
            );
          });
        }}
      />
    </div>
  );
};
